import {AxiosInstance} from "axios";
import Settings from "../model/settings/Settings";

/**
 * Api for installer portal settings.
 */
export default class SettingsApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch settings.
	 * @returns {Promise<Settings>} Promise containing installer portal settings.
	 */
	fetchSettings(): Promise<Settings> {
		const url = `/settings`;
		return this.axiosInstance.get(url).then(resp => Settings.fromJson(resp.data));
	}

	/**
	 * Fetch build number.
	 * @return {Promise<string>}
	 */
	fetchBuildNumber(): Promise<string> {
		const url = '/info';
		return this.axiosInstance.get(url).then(resp => {
			return (
				resp.data["web-ui-build"].number
			);
		});
	}

	/**
	 * Get boiler unit category identifier.
	 * @returns {Promise<string>} boiler unit category identifier.
	 */
	getBoilerUnitCategoryId(): Promise<string> {
		const url = `/api/web/settings/primary_asset_category`;
		return this.axiosInstance.get(url).then((resp) => resp.data.value);
	}
}